import { render, staticRenderFns } from "./AboveFooter.vue?vue&type=template&id=67e2c394"
import script from "./AboveFooter.vue?vue&type=script&lang=js"
export * from "./AboveFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports